module.exports = __webpack_public_path__ + "img/logo_obra_digital.75cfd0d7.jpg";